import type { SettingValue } from './api';

export type ValueType = 'bool' | 'int' | 'nullable_int';

export interface SettingDraft {
  value: SettingValue;
  text: string;
}

const BOOL_KEYS = new Set([
  'public_user_registration',
  'public_tenant_registration',
  'tenant_invite_required',
]);

const NULLABLE_INT_KEYS = new Set([
  'max_tenants_per_user',
  'max_members_per_tenant',
]);

export function inferValueType(key: string, current: SettingValue): ValueType {
  if (BOOL_KEYS.has(key) || typeof current === 'boolean') return 'bool';
  if (NULLABLE_INT_KEYS.has(key)) return 'nullable_int';
  return 'int';
}

export function toDraft(value: SettingValue): SettingDraft {
  return {
    value,
    text: value === null || value === undefined ? '' : String(value),
  };
}

export interface ParsedDraft {
  ok: true;
  value: SettingValue;
}

export interface DraftError {
  ok: false;
}

export function parseDraft(
  key: string,
  draft: SettingDraft,
): ParsedDraft | DraftError {
  const valueType = inferValueType(key, draft.value);

  if (valueType === 'bool') {
    return { ok: true, value: Boolean(draft.value) };
  }

  const trimmed = draft.text.trim();
  if (valueType === 'nullable_int' && trimmed === '') {
    return { ok: true, value: null };
  }
  if (trimmed === '' || !/^-?\d+$/.test(trimmed)) {
    return { ok: false };
  }
  return { ok: true, value: Number(trimmed) };
}

export function valuesEqual(a: SettingValue, b: SettingValue): boolean {
  if (a === null || b === null) return a === b;
  return a === b;
}
